// eslint-disable-next-line import/prefer-default-export
export const getQueryAsObject = (): Record<string, unknown> => {
  if (typeof window === 'undefined') {
    return {};
  }

  const urlQueryString = window.location.search.slice(1);
  if (!urlQueryString.length) {
    return {};
  }
  const urlQueryParts = urlQueryString.split('&');
  const query: Record<string, unknown> = {};
  urlQueryParts.forEach(part => {
    const [key, value] = part.split('=');
    try {
      query[decodeURIComponent(key)] = JSON.parse(decodeURIComponent(value));
    } catch (_) {
      // if can't parse it, assume it is bare text
      query[decodeURIComponent(key)] = decodeURIComponent(value);
    }
  });
  return query;
};
